export default class DepartmentsModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
